export const es = {
  allow_whatsapp_messages: 'Permitir mensajes por WhatsApp',
  assigned_to_me: 'Asignadas a mí',
  attach_file: 'Adjuntar archivo',
  attention_queues: 'Colas de atención',
  attention_queues_hint:
    'Quiénes atienden y a dónde caen las conversaciones sin clasificar.',
  billable_conversations: 'Conversaciones facturables',
  billable_messages: 'Mensajes facturables',
  business_hours: 'Horario comercial',
  business_hours_hint:
    'Se evalúa en la zona horaria de la empresa. Un día sin horario está cerrado.',
  commercial_messages: 'Mensajes comerciales',
  communication_preferences: 'Preferencias de comunicación',
  communication_preferences_hint:
    'Determinan qué avisos recibe el cliente por WhatsApp.',
  confirm_sale_stock:
    'No hay suficiente inventario. ¿Desea continuar con la venta?',
  abbr: 'Abreviatura',
  account: 'Cuenta',
  accumulated_quantity: 'Cantidad acum.',
  action: 'Acciones',
  activate: 'Activar',
  active: 'Activo',
  actor: 'Autor',
  add_cost: 'Sumar costo',
  add_discount: 'Agregar descuento',
  add_extra: 'Agregar extra',
  add_fields: 'Se agregaron los siguientes campos: ',
  add_item_value: 'Agregar valores',
  add_price: 'Sumar precio',
  add_product_partial:
    'El producto se guardará como inactivo hasta que la data requerida sea \
    llenada totalmente',
  add_product: 'Agregar producto',
  add_quantity: 'Agregar cantidad',
  add_user_group: 'Agregar usuarios a grupos',
  add_user_permissions: 'Agregar permisos a usuarios',
  add: 'Ingresar {value}',
  add2: 'Añadir a {value}',
  added: 'Se agregó',
  additional_data: 'Datos adicionales',
  additional_side: 'Información adicional',
  address: 'Dirección',
  address2: 'Dirección 2',
  addressee: 'Para:',
  advertisement: 'Publicidad',
  alert: 'Alerta',
  all: 'Todos',
  amount: 'Cantidad|Cant',
  and: 'y',
  apparel: 'Prenda | Prendas',
  apparel_brand: 'Marca de Prenda | Marcas de Prendas',
  apparel_brands: 'Marcas',
  apparel_color: 'Color Textil | Colores Textiles',
  apparel_configuration: 'Configuración de Textiles',
  apparel_gender: 'Género | Géneros',
  apparel_genders: 'Géneros',
  apparel_name: 'Prenda | Prendas',
  apparel_names: 'Prendas',
  apparel_product_label: 'Textil',
  add_catalog_entry: 'Agregar',
  apparel_style: 'Estilo | Estilos',
  apparel_styles: 'Estilos',
  // ------------------------------------------------------------
  // APPAREL TRANSLATIONS
  // ------------------------------------------------------------
  apparel_names_translations: {
    't-shirts': 'Playeras',
    caps: 'Gorras',
    aprons: 'Mandiles',
    backpacks: 'Mochilas'
  },
  apparel_company_required:
    'Esta sesión no tiene una empresa ERP cargada. Asocie el usuario a una empresa e inicie sesión de nuevo.',
  apparel_genders_translations: {
    unisex: 'Unisex',
    men: 'Caballeros',
    women: 'Damas',
    youth: 'Juvenil',
    kids: 'Niños',
    toddlers: 'Niños pequeños'
  },
  apparel_styles_translations: {
    'crew-neck': 'Cuello redondo',
    'v-neck': 'Cuello en V',
    'short-sleeve': 'Manga corta',
    'long-sleeve': 'Manga larga',
    sleeveless: 'Sin mangas',
    'with-pocket': 'Con bolsillo',
    'without-pocket': 'Sin bolsillo',
    'without-hood': 'Sin capucha',
    'without-zipper': 'Sin cierre',
    'hoodie-with-kangaroo-pocket': 'Capucha y cangurera',
    'full-zip-hoodie-with-kangaroo': 'Capucha, cangurera y cierre',
    'tag-free': 'Sin etiqueta',
    'tear-away-tag': 'Etiqueta desprendible',
    '5-panel': '5 Paneles',
    '6-panel': '6 Paneles',
    '7-panel': '7 Paneles',
    'pre-curved': 'Visera pre-curvada',
    'flat-bill': 'Visera plana',
    'sandwich-bill': 'Visera tipo sandwich (con borde de color)',
    flexfit: 'Elástica ajustable',
    'with-cuff': 'Con doblez (o con vuelta)',
    'without-cuff': 'Sin doblez (o sin vuelta)',
    patterned: 'Estampado, con patrones',
    'bib-apron': 'Mandil de Peto',
    'bistro-apron': 'Mandil de Chef Largo',
    'waist-apron': 'Mandil de Cintura (Mandil Corto)',
    'cobbler-apron': 'Mandil de Tabardo (Mandil Tipo Chaleco)',
    'cross-back-apron': 'Mandil con Correas Cruzadas',
    'tuxedo-apron': 'Mandil Tipo Esmoquin',
    'dishwasher-apron': 'Mandil para Lavaplatos (Impermeable)',
    'server-apron': 'Mandil para Mesero',
    backpack: 'Morral Tradicional (Mochila)',
    daypack: 'Morral Ligero (Mochila de Diario)',
    'tote-backpack': 'Morral Tipo Bolso de Mano',
    'roll-top-backpack': 'Morral con Cierre Enrollable',
    'sling-bag': 'Morral Cruzado (De un Solo Tirante)',
    'tactical-backpack': 'Morral Táctico (Militar)',
    'hiking-backpack': 'Morral de Senderismo (Excursionismo)',
    'drawstring-bag': 'Morral de Cuerdas (Mochila Saco)'
  },
  fabric_types_translations: {
    '100-cotton': '100% Algodón',
    '100-polyester': '100% Poliéster',
    blends: 'Mezclas',
    'cotton-poly': 'Algodón Poliéster',
    '50-50-blend': 'Mezcla 50/50',
    twill: 'Gabardina (o Sarga)',
    '100-acrylic': '100% Acrílico',
    cotton: 'Algodón',
    'poly-cotton-blend': 'Mezcla de Poliéster y Algodón',
    denim: 'Mezclilla',
    canvas: 'Lona',
    nylon: 'Nylon',
    polyester: 'Poliéster',
    'denier-polyester': 'Poliéster Denier (o Poliéster de alta densidad)',
    'ripstop-poly': 'Poliéster Ripstop (o Poliéster antidesgarro)'
  },
  apparel_colors_translations: {
    black: 'Negro',
    white: 'Blanco',
    'navy-blue': 'Azul marino',
    red: 'Rojo',
    orange: 'Naranja',
    gray: 'Gris'
  },
  approvalStatus: 'Estado de aprobación',
  approve: 'Aprobar',
  approved: 'Aprobado',
  aproved_purchase_order: 'Orden de compra aprobada',
  aproved_quote: 'Aprobar cotización',
  area: 'Área | Áreas',
  are_sure: '¿Está seguro?',
  are_you_sure: '¿Está seguro que desea {action} {model}?',
  as_producer: 'Como productor',
  assign_people: 'Asignar {value}',
  assign: 'Asignar',
  assignament_date: 'Fecha de asignación',
  assignaments: {
    department: 'Departamento asignado en el proyecto',
    designers: 'Diseñadores asignados en el proyecto',
    drivers: 'Choferes asignados en el proyecto',
    productions: 'Productores asignados en el proyecto',
    suborderToDrivers: 'Subórdenes asignadas al chofer'
  },
  assignDesigner: 'Asignar diseñador',
  assignDesigners: 'Debe asignar diseñadores al proyecto',
  assignDriver: 'Asignar chofer',
  assigned: '{value} asignado',
  assignedDesign: 'Asignado a diseñador',
  assignedDesigns: 'Diseños asignados',
  assignedOneDesigner: 'Sólo puede asignar un diseñador',
  assignedOneDriver: 'Sólo puede asignar un chofer',
  assignedProducts: 'Productos asignados',
  assignProduction_no:
    'Al aprobarse el diseño, podrá asignar los miembros del equipo de \
    producción para esta Suborden',
  assignProducer: 'Asignar departamento de producción o máquina',
  assignProduction: 'Departamentos de producción',
  assignProductions: 'Debe asignar un departamento de producción al proyecto',
  assignSubOrder: 'Asignar Suborden',
  at_home: 'A domicilio',
  attach_images: 'Clic aquí para adjuntar imágenes manualmente',
  attachments: 'Archivos adjuntos',
  attributes: 'Atributos',
  audit_system: 'Realizado por el sistema',
  audit: 'Auditoria',
  available: 'Disponible',
  avalaibleDesigners: 'Diseñadores disponibles para proyecto',
  back: 'Volver',
  background_color: 'Color de fondo',
  background_image: 'Imagen de fondo',
  background_url: 'Url',
  background: 'Fondo',
  backup_schemas: 'Respaldar base de datos',
  balance: 'Balance',
  banners: 'Pancartas',
  base_salary: 'Salario base',
  base: 'Base',
  basic: 'Información básica',
  before: 'Antes',
  billing_address: 'Dirección de Cobro',
  billing_and_payment: 'Facturación y pagos',
  blocked: 'Bloqueado',
  body: 'Cuerpo',
  bool: 'Sin precio',
  boolean: 'Booleano',
  both: 'Ambas',
  bought_date_and_rent_date: 'Fecha de Compra o Alquiler',
  bought_date: 'Fecha de compra',
  brand: 'Marca',
  brandModels: 'Modelos de {brand}',
  bussiness_info: 'Información de empresa',
  buy: 'Compra',
  by_ranges: 'Por rangos',
  bypercent: 'Por porcentaje',
  calendar: 'Calendario',
  can_be: 'Puede ser',
  cancel_quotation_validation: 'La razón debe contener al menos un carácter',
  cancel_quotation: 'Indique la razón por la que cancelará la cotización',
  cancel_specific: 'Cancelar {value}',
  cancel: 'Cancelar',
  canceled: 'Cancelada',
  cancelorder: '¿Quieres cancelar la orden {order}?',
  cant_active:
    'Debe rellenar la información de todos los pasos del formulario antes para \
    poder modificar esta opción',
  carrouselTips: 'Carrusel de consejos',
  cash: 'Efectivo',
  category: 'Categoria | Categorias',
  cc: 'Tarjeta de credito',
  cellphone: 'Celular',
  change_status: {
    mail_delivery_notification: 'Verificación de envío de correo ',
    shipment_preview: 'Previsualización de envío',
    ask: '¿Desea enviar la notificación por correo directamente al cliente?',
    notification: 'Cambio de estado de una suborden',
    to: '¿Desea cambiar el estado de la suborden a {value}?'
  },
  change_to: 'Cambia a',
  change: 'Cambiado | Cambiada | Cambiar',
  changeprice: 'Cambio de precio|Cambio de precios',
  chat_not_started: 'No se pudo enviar el mensaje',
  chat: 'Chat',
  check: 'Cheque',
  city: 'Ciudad',
  clean_image: 'Limpiar la imagen',
  clear: 'Limpiar',
  click_repository: 'Clic en el recuadro para enviar al repositorio',
  click_to_enlarge: 'Clic para ampliar',
  clone: 'Clonar',
  cloned: 'clonado',
  close: 'Cerrar',
  code: 'Código',
  color_nav: 'Color de barra de navegación',
  color_toolbar: 'Color de barra lateral',
  color: 'Color|Colores',
  cols_empty: 'Debe agregar al menos una columna en {col}',
  cols_must_be_unique: 'El título de las columnas debe ser único',
  cols_tab_be_unique: 'La tabulación de las columnas debe ser única',
  column_compare:
    'La columna de cantidades de la matriz de detalle debe ser igual que el de \
    la matriz del producto',
  column: 'Columna',
  commission_assigned: 'Comisión Asignada',
  commission: 'Comisión|Comisiones',
  commissionPermission:
    'La condición es el número de ventas a realizar, el valor siempre será \
    mayor o igual que {val}',
  companies: 'Empresas',
  company_address: 'Dirección de la empresa',
  company_info: 'Información de la empresa',
  company_management: 'Administración de empresas',
  company_name: 'Nombre de la empresa',
  company_settings: 'Configuración de empresa',
  tenant_guide: 'Guía de bienvenida',
  tenant_guide_empty: 'La empresa aún no ha completado la guía de bienvenida.',
  tenant_guide_completed: 'Guía completada',
  tenant_guide_primary_service: 'Servicio principal',
  company: 'Empresa',
  concurrence: 'Concurrencia del cliente',
  condition: 'Condición',
  confirm_change_designer: '¿Desea cambiar el diseñador asignado?',
  confirm_delete:
    '¿Desea eliminar este registro? Esta acción no se puede deshacer',
  confirm: 'Confirmar',
  connect_whatsapp: 'Conectar WhatsApp',
  connected: 'Conectado | Conectados',
  contact: 'Contacto | Contactos',
  conversation_not_opened: 'No se pudo abrir la conversación',
  conversation: 'Conversación | Conversaciones',
  copy_prices: 'Precios copiados',
  copy_ranges: 'Copiar rangos | Rangos copiados | Rangos editados',
  copy: 'Copiar',
  copyright: 'Todos los derechos reservados.',
  correction: 'Corrección',
  corrective: 'Correctivo',
  preventive: 'Preventivo',
  cost_by_dimensions: 'Costo calculado por las dimensiones',
  cost_lat_prom: 'Costo Promoción (Latinoamérica)',
  cost_lat: 'Costo (Latinoamérica)',
  cost_prom: 'Costo de Promoción',
  cost_suggest: 'Costo total',
  cost: 'Costo | Costos',
  costalert: 'El costo de su producto debe ser mayor que 0',
  country: 'País',
  create_btn: 'Crear',
  create_customer: 'Crear cliente',
  create_email: 'Crear email',
  create_matrix_template: 'Crear plantilla de matriz',
  create_quotation: 'Crear cotización',
  create_value: 'Crear Valor',
  create: 'Crear {model}',
  created: 'Creado | Creada',
  created_at: 'Creado El',
  creation_date: 'Fecha de creación',
  creation_user: 'Usuario creador',
  credentials: 'Credenciales',
  credit_limit: 'Límite de Crédito',
  cumulative: 'Acumulativo',
  currency_info: 'Información de Monedas',
  currency: 'Moneda|Monedas',
  current_status: 'Estado actual',
  customer_manager: 'Administrador de clientes',
  customer_origin_date: 'Fecha de inscripción del cliente',
  customer_origin: 'Origen del Cliente',
  customer_without_conversation:
    'Este cliente todavía no escribió por WhatsApp',
  customer: 'Cliente|Clientes',
  customerAddress: 'Dirección cliente',
  customerCompany: 'Nombre del cliente o empresa',
  customersReport: 'Reporte de clientes',
  daily: 'Diario',
  dark_mode: 'Modo Oscuro',
  dark: 'Color oscuro',
  dashboard_default: 'Elegir opción por defecto',
  dashboard: 'Tablero',
  date_from: 'Desde',
  date_pay: 'Fecha de Pago',
  date_to: 'Hasta',
  date: 'Fecha',
  dateDelivery: 'Fecha de entrega',
  dateDesign: 'Fecha de diseño',
  dateDone: 'Fecha de cierre del pedido',
  dateOrder: 'Fecha de la orden',
  dateProduction: 'Fecha de producción',
  dates: 'Fechas',
  day_terms: 'Días para pagar crédito',
  days_list: {
    mon: 'Lunes',
    tue: 'Martes',
    wed: 'Miércoles',
    thu: 'Jueves',
    fri: 'Viernes',
    sat: 'Sábado',
    sun: 'Domingo'
  },
  days: 'Días',
  decimal: 'Decimal',
  default_field: 'Seleccione una fórmula de precio como predeterminada',
  default: 'Por defecto',
  default_queue: 'Cola por defecto',
  deincorporation: 'Desincorporación',
  delete_matrix: 'Borrar Matriz',
  delete_no:
    'Este estado no se puede borrar porque contiene unas subórdenes. Primero, \
    cambie las subórdenes a un estado vigente',
  delete_record_question: '¿Desea eliminar este registro?',
  delete: 'Borrar|Borrado',
  deleted: 'Se eliminó',
  delivery_at_home: 'Entrega - A domicilio',
  delivery_date: 'Fecha de entrega',
  delivery_notifications: 'Notificaciones de entrega',
  delivery_pickup: 'Entrega - En el local',
  delivery_status: 'En entrega | Rechazado | Entregado',
  delivery: 'Entrega',
  deliverytime: 'Tiempo de entrega',
  department: 'Departamento de producción',
  deploy: 'Desplegar',
  description_lat: 'Descripción (Latinoamérica)',
  description: 'Descripción',
  descriptions: 'Descripciones',
  deselect_image: 'Deseleccionar imagen',
  design_completed: 'Diseños completados',
  design_finished: 'Diseño - Finalizado',
  design_in_process: 'Diseño - En proceso',
  design_in_wait: 'Diseño - En espera',
  design_notifications: 'Notificaciones de diseño',
  design_rejected: 'Diseño - Rechazado',
  design_status: 'Estado de diseño',
  design_under_review_approved: 'Diseño en revisión - Aprobado',
  design_under_review_in_design: 'Diseño en revisión - En diseño',
  design_under_review_in_wait: 'Diseño en revisión - En espera',
  design_under_review_rejected: 'Diseño en revisión - Rechazado',
  design_under_review: 'Diseño en revisión',
  design: 'Diseño | Diseños',
  designer: 'Diseñador',
  designerOnDuty: 'Diseñador trabajando',
  designerReport: 'Reporte de actividad para diseñadores',
  designers: 'Diseñadores',
  assigned_designer_subject: 'Asignación de suborden: {suborder}',
  assigned_designer_body: `Hola {designerName},

Te compartimos que se te asignó una nueva orden de diseño.

Por favor, revísala cuando te sea posible y dale seguimiento. Si necesitas más información, archivos o tienes alguna duda sobre lo que se requiere, avísanos.

Gracias.

Saludos,
{companyName}`,
  detail: 'Detalle',
  details_production: 'Detalles de producción',
  dimension: 'Dimensiones',
  dinamic_cost: 'Costo Dinámico',
  discard: 'Descartar',
  disconnected: 'Desconectado | Desconectados',
  discount: 'Descuento',
  discrepancy: 'Discrepancia | Discrepancias',
  everyone: 'Todos',
  friday: 'Viernes',
  inbox: 'Bandeja de entrada',
  integration_disabled_globally:
    'La integración de WhatsApp está apagada para toda la plataforma.',
  integration_enabled_globally:
    'La integración de WhatsApp está activa para toda la plataforma.',
  last_30_days: 'Últimos 30 días',
  last_7_days: 'Últimos 7 días',
  last_90_days: 'Últimos 90 días',
  loaded: 'Cargadas',
  marketing: 'Promociones y mensajes comerciales',
  matching_customers: 'Clientes que coinciden',
  message_preview: 'Así le va a llegar al cliente',
  message_to_customer: 'Mensaje para el cliente',
  missing: 'Sin cargar',
  monday: 'Lunes',
  no_approved_templates:
    'Todavía no hay plantillas aprobadas por la plataforma para esta imprenta.',
  no_conversations: 'No hay conversaciones',
  no_messages: 'No hay mensajes',
  no_queues: 'No hay colas configuradas',
  no_quotations: 'Este cliente no tiene cotizaciones',
  no_usage: 'Sin consumo en el período',
  notification_whatsapp_account_disabled:
    'WhatsApp dio de baja la conexión del {phone}. No se pueden enviar ni recibir mensajes hasta resolverlo con la plataforma.',
  notification_whatsapp_message: '{name}: {preview}',
  notification_whatsapp_token_expired:
    'La conexión de WhatsApp del {phone} venció el {date}. Hay que volver a conectarla para poder enviar.',
  notification_whatsapp_token_expiring:
    'La conexión de WhatsApp del {phone} vence el {date}. Volvé a conectarla antes de esa fecha.',
  number_managed_by_provider: 'Lo administra el proveedor',
  onboarding_cancelled: 'Se cerró la ventana sin completar la conexión',
  onboarding_failed: 'No se pudo conectar la cuenta de WhatsApp',
  onboarding_hint:
    'Podés conectar un número que la imprenta ya atiende desde la aplicación de WhatsApp Business, siempre que sea la versión 2.24.17 o posterior. Al conectarlo se desvinculan los dispositivos vinculados de ese número, como WhatsApp Web.',
  onboarding_incomplete:
    'La ventana no devolvió la cuenta ni el número. Volvé a intentarlo y elegí un número al final del asistente.',
  onboarding_intro:
    'Conectá el número de WhatsApp de la imprenta. Se abre una ventana de la plataforma donde elegís la cuenta y el número; al terminar queda listo para enviar y recibir.',
  onboarding_not_available:
    'La plataforma todavía no tiene cargados los datos de la aplicación. Es configuración del administrador del sistema.',
  open_whatsapp_chat: 'Abrir la conversación de WhatsApp',
  operational_messages: 'Mensajes operativos',
  order_updates: 'Actualizaciones de órdenes',
  out_of_hours_message: 'Respuesta fuera de horario',
  out_of_hours_message_hint:
    'Se envía una vez cada doce horas por conversación.',
  out_of_hours_queue: 'Cola fuera de horario',
  payment_reminders: 'Recordatorios de pago',
  period: 'Período',
  physicalDiscrepancy: 'Reporte de discrepancia de inventario físico',
  physicalInventory: 'Inventario físico | Inventarios físicos',
  discrepancynote: 'Nota de discrepancia',
  dispatchAddress: 'Dirección de despacho',
  distance: 'Distancia',
  done: 'Listo',
  dont_templates_email:
    'Este estado no posee plantilla de correo, por favor editar correo \
    manualmente',
  email_template_required:
    'Debe configurar previamente una plantilla de correo para el estado de suborden.',
  email_smtp_required:
    'Debe configurar un servidor de correo SMTP antes de crear una plantilla.',
  download: 'Descargar',
  draft: 'Borrador',
  drag_and_drop_the_image_to_this_box:
    'Arrastre y suelte la imagen a este recuadro',
  drag_drop_image: 'Arrastra y suelta una imagen',
  driver: 'Chofer | Choferes',
  edit_btn: 'Editar',
  edit_product_partial:
    'El producto permanecerá inactivo hasta que la data requerida sea llenada \
    totalmente',
  edit_product: 'Editar producto',
  edit: 'Editar',
  editable_active:
    'Para activar este botón necesita credencial de administrador',
  editable: 'Editable',
  edited: 'Editado | Editada',
  editing: 'Editar {value}',
  email_edit:
    'Si desea confirmar o editar la información del correo, presione el botón \
    de editar',
  email_sent: 'Correo electrónico enviado',
  email_setting: {
    default_iprint_email_service: 'Servicio de correo de Iprint',
    default_setting: 'Configurar por defecto',
    email_SMTP_setting: 'Configuración SMTP de correo',
    gmail: {
      google: 'Google',
      gmail: 'Gmail',
      setting_gmail: 'Configuración de Gmail',
      msg1: 'Prerrequisito: estar logueado en el navegador con su cuenta de \
        Google.',
      msg2: 'Ingresar al siguiente link:',
      msg3: 'Para generar la contraseña, registre la aplicación: ',
      msg4: 'Por favor ingrese las credenciales de su cuenta (Correo y \
        contraseña).'
    },
    host: 'Servidor',
    host_port: 'Puerto del servidor',
    hour: 'Hora',
    smtp_type: 'Tipo de SMTP',
    main: 'Principal',
    outlook: {
      outlook: 'Outlook',
      setting_outlook: 'Configuración de Outlook',
      msg1: 'Prerrequisito: estar logueado en  el navegador con su cuenta de \
        Outlook.',
      msg2: 'Ingresar al siguiente link:',
      msg3: 'Permitir que los dispositivos y aplicaciones usen la \
        configuración POP: Si',
      msg4: 'Por favor ingrese las credenciales de su cuenta (Correo y \
        contraseña).'
    },
    use_tls: 'Use TLS',
    other: {
      setting_other: 'Configurar otro',
      msg1: 'Prerrequisito: Contar con los accesos para la configuración SMTP \
        del servicio de correo de su preferencia.',
      msg2: 'Llenar todos los datos que se solicitan en el formulario de esta \
        sección.'
    }
  },
  email_subdomain: 'Aprobación de subdominio de {value}',
  email: 'Correo electrónico | Correos electrónicos',
  emails_list: 'Lista de correos',
  empty_data: 'No se encontraron registros',
  empty_message: 'Debe especificar el contenido del mensaje',
  empty_states: 'No se encontraron estados',
  end_date: 'Fecha fin',
  equipment_maintenance: 'Mantenimiento de equipo',
  equipment: 'Equipo',
  equipmentReport: 'Reporte de equipo',
  equipments_manage: 'Gestión de equipos',
  equipments: 'Equipos',
  error_send_email: 'Error al enviar el correo',
  example: 'Ejemplo',
  expected_date: 'Fecha esperada',
  expense_type: 'Tipo de gasto',
  expense_validation:
    'La fecha de inicio no puede ser mayor o igual que la fecha final | No hay \
    meses en ese rango de fechas | No hay semanas en ese rango de fechas',
  expense: 'Gasto|Gastos',
  expenseAccount: 'Cuentas de gasto',
  expenseCategory: 'Categoria de gasto',
  expenses_recurring: 'Gastos recurrentes',
  expenses_regular: 'Reporte de pagos',
  expensesReport: 'Reporte de gastos',
  expiration_days: 'Días de expiración',
  expired: 'Sesión expirada',
  extra_cost: 'Costos extras',
  extra_discount: 'Extras/Descuentos',
  extra: 'Extra',
  f2key: 'Pulse la tecla F2 para ver costo del producto',
  fabric_type: 'Tipo de Tela | Tipos de Telas',
  fabric_types: 'Tipos de Telas',
  favorite: 'Favorito',
  fax: 'Fax',
  fields_changed: 'Los siguientes campos fueron modificados: ',
  file_recomended:
    'Tamaño: 300px Alto x 300px Ancho, Resolución: 120Dpi, Tipos de archivos: \
    PNG-24 Alta Resolución',
  file_type: 'Tipo de archivo',
  file: 'Archivo',
  fill_company_address:
    'Complete los campos de dirección de la empresa primero',
  fill_fields: 'Complete todos los campos requeridos primero',
  filter_role: 'Filtrar por rol',
  filter: 'Filtros',
  finalize: 'Finalizar',
  finished: 'Finalizada',
  finishedAndRemove:
    'Al finalizar la orden, sus imágenes serán borradas del sistema',
  first_name: 'Nombres',
  forgot: '¿Olvido su contraseña?',
  form: 'Formulario',
  format_date: 'Formato de fecha',
  format: 'Formato|Formatos',
  formula_model: 'Fórmula Modelo',
  formula_simple: 'Fórmula',
  formula: 'Fórmula de precios',
  formulaDivisionZero: 'División entre 0 inválida',
  formulaNoValid: 'Fórmula inválida',
  formulattributes: 'Atributos de fórmula',
  fraction: 'Fracción',
  from: 'Desde',
  fullname: 'Nombre completo',
  general: 'General|Lista General de Productos',
  given_to: 'Entregado a',
  globaltax: 'Impuesto|Impuestos',
  go_home: 'Ir al inicio',
  group_title: 'Título del grupo',
  has_credit: 'Crédito',
  hasCondition: 'Con condición',
  height: 'Altura',
  hidden: 'Oculto',
  hide: 'Ocultar',
  historical: 'Histórico',
  history_customer: 'Historial del cliente',
  history_product: 'Histórico de productos',
  history_supplier: 'Histórico del proveedor',
  history: 'Histórico de {model}|Histórico del {model}',
  hours: 'Horas',
  identification: 'Identificación',
  image: 'Imagen',
  image_design_and_approval: 'Diseño y aprobación de imagen',
  image_error_message:
    'Lo lamentamos, pero algo salió mal en el proceso. Por favor, inténtelo \
    nuevamente o contáctenos.',
  in_design: 'En diseño',
  in_process: 'En proceso',
  in_production: 'En producción',
  in_wait: 'En espera',
  inactive: 'Inactivo',
  incorporation: 'Incorporación',
  increase: 'Incrementar',
  increaseStock: 'Incrementar existencia',
  invalid_type_and_file_please_select_one_allowed:
    'Tipo e archivo invalido, por favor seleccione uno permitido.',
  inventoriable: 'Inventariable',
  inventoriable_push: 'Inventariable Notificación Push',
  inventory: 'Inventario',
  invoice: 'Factura',
  invoices: 'Facturas',
  invoiceSetting: 'Configuración de factura',
  invoicesReport: 'Reporte de facturas',
  ip_addr: 'Direccion IP',
  is_multipliable: 'Multiplicable por la cantidad',
  is_required: '{name} es requerido',
  item: 'Ítem',
  keep_off: 'Alejar',
  label: 'Etiqueta | Etiquetas',
  last_name: 'Apellidos',
  leave: 'Olvidar|olvidado',
  length: 'Longitud',
  less_price: 'El precio es menor al costo',
  level: 'Tipo de cliente | Tipos de cliente',
  levelRequired: 'El tipo de cliente es requerido para los precios',
  lineal_meter: 'Metro lineal',
  list_schemas: 'Listado de los schemas almacenados',
  list: 'Lista',
  loading_image: 'Cargando...',
  login_failed: 'Fallo al iniciar sesión',
  license_account_suspended:
    'El acceso a iPrintPOS está suspendido por el estado de la licencia de tu empresa. Contacta al administrador.',
  login: 'Iniciar sesión',
  loginlogs: 'Registros de ingreso',
  logout: 'Cerrar sesión',
  main_email: 'Correo principal',
  main_matrix: 'Matriz Principal',
  main_status: 'Estado principal',
  maintenance_recurrence: 'Recurrencia de mantenimiento de equipo',
  maintenance: 'Mantenimiento',
  matrix_prices: 'Matriz de precios',
  matrix_table: {
    add_cols: 'Agregar columna',
    add_rows: 'Agregar fila',
    remove_cols: 'Eliminar columna',
    remove_rows: 'Eliminar fila',
    initial_range: 'Rango inicial',
    final_range: 'Rango final',
    tab_title: 'Título de la pestaña'
  },
  matrix_template: 'Matriz plantilla',
  matrix: 'Matriz',
  max_height: 'Altura máxima',
  max_size: 'Tamaño máximo',
  max_width: 'Ancho máximo',
  measure: 'Unidad de medida | Und. medida',
  measureRequired:
    'La fórmula de venta es requerida, los productos sin este valor estarán \
    inactivos hasta que se les asigne.',
  member: 'Miembro | Miembros',
  message: 'Mensaje',
  minReorder: 'Reorden Mínimo | Reporte de Inventario Mínimo',
  pricing_change_notice:
    'Desde el {date} la plataforma cobra tambien las respuestas dentro de las 24 horas y las plantillas de utilidad.',
  production_notifications: 'Notificaciones de producción',
  queue_users_hint: 'Sin usuarios, el aviso va a toda la empresa.',
  quotation_message_hint: 'Se envía junto al PDF de la cotización.',
  quotation_not_sent: 'No se pudo enviar la cotización',
  quotation_sent: 'Cotización enviada',
  received_messages: 'Recibidos',
  reconnect_whatsapp: 'Volver a conectar',
  region: 'Código de país',
  region_hint: 'Dos letras. Se usa para interpretar los teléfonos.',
  related: 'Relacionado',
  saturday: 'Sábado',
  sdk_not_loaded: 'No se pudo cargar la ventana de la plataforma',
  see_orders: 'Ver órdenes',
  select_conversation: 'Seleccione una conversación',
  select_quotation: 'Seleccione una cotización',
  send_quotation: 'Enviar cotización',
  sent_messages: 'Enviados',
  stock_min_reached: 'Se alcanzó el mínimo en el producto: {product}',
  minStock: 'Existencia Mín.',
  minutes: 'Minutos',
  mode: 'Modo',
  model_product: 'Producto Modelo',
  model: 'Modelo',
  models: 'Modelos',
  month_list: {
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre'
  },
  month: 'Mes',
  monthly: 'Mensual',
  more_info: 'Más Información',
  movement_type: 'Tipo de movimiento',
  movement: 'Movimiento | Movimientos',
  movementsReport: 'Reporte de movimientos',
  msg_color: 'Color del mensaje',
  msg: 'Mensaje',
  multi_choice: 'Selección múltiple',
  must_be_numeric: 'deben ser númericos',
  my_profile: 'Mi perfil',
  name: 'Nombre',
  new_chat: 'Nuevo Chat',
  new_order_status: 'Nuevo estado de orden',
  new_package: 'Nuevo Paquete',
  new_password: 'Nueva contraseña',
  new: 'Nuevo',
  newMessage: 'Nuevo mensaje en la orden',
  next_date: 'Siguiente fecha',
  next_number: 'Siguiente número',
  next_sub_state: 'Nuevo subestado',
  next: 'Siguiente',
  nextStatus: 'Siguiente estado {state}',
  no_addi_data: 'No hay datos adicionales',
  no_changes: 'No hay cambios',
  no_matrix: 'Debe agregar una matriz a la plantilla',
  no_notifications: 'No hay nuevas notificaciones',
  no_producers: 'No hay productores registrados',
  no_roles: 'Sin roles',
  no_suborders_outstanding: 'No hay subórdenes pendientes de pago',
  notes_chat: 'Notas/Chat',
  notifications_events: 'Notificaciones y eventos',
  notifications: 'Notificaciones',
  notification_suborder_update: '{status} | {name}',
  number_control: 'Número de control',
  number_increment: 'Número de incremento',
  number: 'Número',
  object_repr: 'Representación de objetos',
  observation: 'Observación',
  of: 'de',
  old_password: 'Contraseña anterior',
  on_bytes: 'En Bytes',
  on_pixels: 'En píxeles',
  one_column: 'Una columna',
  open: 'Abrir',
  operator: 'Operador',
  operators: 'Operadores',
  optional_field: 'Opcional',
  optional: '{value} (opcional)',
  order_code: 'Código de la orden',
  order_name: 'Nombre de la orden',
  order_quantity: 'Cantidad ordenada',
  order_status: 'Estatus de la orden',
  order: 'Orden | Órdenes',
  ordercanceled: 'Orden {order} cancelada',
  ordercreated: 'Orden {order} creada',
  orderdelayed: 'Orden retrasada',
  orderend: 'Orden {order} finalizada',
  orderquote: 'Orden {order} en proceso de Cotización',
  orderstatus: 'Estado de las subórdenes',
  status_change_subject:
    'Cambio de estado del producto {product}, de {old} a {new}',
  orderupdate: 'Cambio de estado del producto {product}, de {old} a {new}',
  other_settings: 'Otros ajustes',
  other: 'Otro',
  out_of_range: 'Fuera de rango',
  outsource: 'Tercerización',
  outstanding: 'Pendiente',
  overview: 'Visión General',
  package: 'Paquete',
  padding: 'Relleno',
  page: 'Página',
  pagenotfound: 'Error 404: Página no encontrada',
  paid: 'Pagado|Pagada',
  partial: 'Entrega parcial',
  partialReception: 'Recepción parcial',
  participant: 'Participantes',
  password_recovery: 'Recuperación de contraseña',
  password: 'Contraseña | Confirmar contraseña',
  pay: 'Pago | Pagar',
  payment_address: 'Dirección de Pago',
  payment_amount: 'Monto a pagar',
  payment_number: 'Número de Pago',
  payment_ref: 'Pago referencial',
  payment_type: 'Tipo de Pago',
  payment: 'Pago | Pagos',
  paymenttype: 'Método de pago',
  pdocument: 'Documento de compra',
  pending_quantity: 'Cantidad faltante',
  percent: 'Porcentaje',
  perimeter: 'Perímetro',
  permanent: 'Permanente',
  permissionnotfound:
    'Error 403: No tiene permisos suficientes para entrar aquí',
  permissions_select: 'Seleccione los permisos',
  permissions: 'Permisos',
  perpage: 'Por página',
  personal_info: 'Información Personal',
  phone_number: 'Número de Teléfono',
  phone: 'Teléfono | Teléfonos',
  photo: 'Foto',
  pick_a_image: 'Elige una imagen',
  pickup: 'En el local',
  position: 'Posición',
  image: 'Imagen',
  duration: 'Duración',
  postproduction: 'Post-Producción',
  prefix: 'Prefijo',
  prefix_en: 'Prefijo (EN)',
  prefix_es: 'Prefijo (ES)',
  preprocess_approved: 'Preproceso - Aprobado',
  preprocess_canceled: 'Preproceso - Cancelado',
  preprocess_quote: 'Preproceso - Cotización',
  preprocess_sended_quote: 'Preproceso - Cotización enviada',
  preprocess: 'Pre-Proceso',
  preproduction: 'Pre-Producción',
  prev: 'Previo',
  previous_date: 'Fecha anterior',
  previous_suborder_status: 'Estado anterior',
  price_calculation: 'Cálculo de precios',
  price: 'Precio | Precios | Tipo de precio',
  pricenegative: 'El precio no puede ser negativo',
  pricepurchase: 'Precio de compra',
  pricepurchaseplus: 'Precio de compra + extra',
  pricesale: 'Precios de venta',
  pricespecial: 'Precio especial',
  pricesuggest: 'Precio sugerido',
  priceZero:
    'Los precios que sean 0 se obviarán y se asumirá el monto del precio \
    sugerido',
  primary_color: 'Color primario',
  print: 'Imprimir {value}',
  printquality: 'Calidad de impresión',
  prodcategory: 'Categoría de producto',
  prodlist: 'Listado de Productos',
  prodstatus: 'Estado de los productos',
  product_catalog: 'Catálogo de productos',
  product_code: 'Código de Producto',
  product_code_preview_unavailable:
    'No se pudo cargar la vista previa del código',
  product_frequency: 'Cantidad vendida',
  product_manage: 'Gestión de productos',
  product_name: 'Nombre del Producto',
  product_price: 'Precio del producto',
  product_sold: 'Productos vendidos',
  product: 'Producto | Productos',
  production_detail: 'Detalle de producción',
  production_finished: 'Producción - Finalizado',
  production_in_design: 'Producción - En diseño',
  production_in_process: 'Producción - En proceso',
  production_in_wait: 'Producción - En espera',
  production_process_start: 'Iniciar proceso de producción',
  production_process: 'Proceso de producción',
  production_ready_to_deliver: 'Producción - Lista a entregar',
  production_ready: 'Producción lista',
  production_rejected: 'Producción - Rechazado',
  production_status: 'Estado de producción',
  production: 'Producción',
  productions: 'Productor | Productores',
  productive_process: 'Proceso productivo',
  productReport: 'Reporte de productos',
  profile: 'Perfil | perfil',
  profit_percent: 'Porcentaje de ganancia',
  profit: 'Ganancia',
  project_name: 'Nombre del proyecto',
  promise_date: 'Fecha de compromiso',
  purchase_history: 'Historial de compras',
  purchase_order_name: 'Nombre de orden de compra',
  purchase_order: 'Orden de compra',
  purchase: 'Compra | Compras',
  purchased_product: 'Producto comprado',
  purchaseproduct: 'Producto de compra',
  purchasesorderlist: 'Listado de órdenes de compra',
  purchaseHistory: 'Historial de compras',
  purchasesReceiver: 'Receptor de compras',
  purchasesReport: 'Reporte de compras',
  push_notifications: 'Notificaciones Push',
  push: 'Push',
  quantity_0: 'La cantidad debe ser mayor a cero',
  quantity: 'Cantidad',
  quick_sale: 'Venta rápida',
  quote: 'Cotización',
  ranges: 'Rangos',
  rating: 'Calificación',
  ready_to_deliver: 'Lista a entregar',
  reason: 'Razón',
  receivable: 'Cuentas por cobrar',
  received_date: 'Fecha de recepción',
  received_greater: 'La cantidad recibida no puede ser mayor que la pendiente',
  received_purchase_order: 'Recepción de productos',
  received_quantity: 'Cantidad recibida',
  received: 'Recibidas',
  recent_chats: 'Chats Recientes',
  reception_date: 'Fecha de recepción',
  reception: 'Recepción',
  recurrent: 'Recurrencia | Recurrente',
  reference: 'Referencia',
  referred: 'Referido',
  register_subdomain: 'Registrar Subdominio',
  register_user: 'Registrar Usuario',
  register: 'Registrar',
  registered: '¿No tienes cuenta?',
  registered2: 'Registrado',
  registerLevel: 'Sólo se pueden registrar cuatro tipos de cliente',
  regular: 'Regular',
  rejected: 'Rechazado',
  removed: 'Eliminado|Eliminada',
  rent_date: 'Fecha de alquiler',
  rent_end_date: 'Fecha final de alquiler',
  rent_start_date: 'Fecha inicial de alquiler',
  rent: 'Alquiler',
  report_type: 'Tipo de reporte',
  reports: 'Reportes',
  repository: 'Repositorio',
  required_field: 'Campo requerido',
  this_field_is_required: 'Este campo es obligatorio',
  required: 'Error guardando, hay campos requeridos vacíos aún',
  resend: 'Reenviar',
  restart: 'Restaurar | Restaurado',
  reverse_transaction_reason: 'Razón de revertir la transacción',
  reverse_transaction: 'Revertir transacción',
  review: 'Reseña',
  role_permissions: 'Permisos del rol',
  roles_areas: 'Área',
  roles: 'Rol | Roles',
  rotate_left: 'Rotar a la izquierda',
  rotate_right: 'Rotar a la derecha',
  rounded: 'Redondear | Habilitar redondeo',
  rounded2: 'Redondeado',
  row_compare:
    'La cantidad de columnas de la matriz de detalle debe ser igual que el de \
    la matriz del producto',
  row_per_page: 'Filas por página',
  row_title: 'Título de la fila',
  rows_empty: 'Debe agregar al menos una fila en {row}',
  rows_must_be_unique: 'El título de las filas debe ser único',
  rush: 'Rush',
  salary: 'Salario | Salarios',
  sale_order: 'Orden de venta',
  sale_price: 'Precio de venta',
  sale: 'Venta | Ventas',
  sales_percent: 'Porcentaje de ventas',
  sales_prices: 'Precios de venta',
  salesman: 'Vendedor | Vendedores',
  salesorderlist: 'Listado de órdenes de venta',
  salesReport: 'Reporte de ventas',
  salessuborderlist: 'Listado por subórdenes de venta',
  same_billing: 'Igual que para cobros',
  same_company_address: 'Igual que la Dirección de la empresa',
  same_payments: 'Igual que para pagos',
  save_backup: 'Se guardó el respaldo de esquema con éxito',
  save_send_backup: 'Se descargó el esquema con éxito',
  save_template:
    'Debe guardar el nombre de la plantilla antes de crear un detalle de \
    producción',
  save: 'Guardar | Guardadas',
  schema: 'Esquema',
  search: 'Buscar',
  second_value: 'El Segundo Valor',
  secondary_color: 'Color secundario',
  section_only: 'Sección',
  section_sub: 'Subsección',
  section: 'Sección de {value}',
  see_matrix: 'Ver Matriz',
  see_more: 'Ver más...',
  see: 'Ver',
  select_prod: 'No hay productos seleccionados',
  select_schema: 'Selecciona el esquema ',
  select_suborder:
    'Debe seleccionar al menos una suborden de venta para habilitar el \
    formulario',
  select: 'Seleccione',
  selectClone: 'Seleccione categoría(s)',
  selectClone2: 'Seleccione categoría(s) a las que desea clonar',
  selectDetail: 'Seleccionar un detalle de producción',
  selection: 'Selección de {value}',
  send_artwork: 'Enviar arte',
  send_email_list: 'Lista de correos enviados',
  send_email_schema: 'Se envió un email con éxito indicando la ruta',
  send_notification:
    'Quieres enviar una notificación al cliente | Puedes notificar al cliente \
    que su pedido ha sido modificado, para que el cliente pueda tener una idea \
    de cómo va su pedido. Sí',
  send_purchase_order: 'Enviar orden de compra',
  send_quote: 'Enviar Cotización',
  send: 'Enviar | Enviado | Enviadas',
  sended_document: 'Orden enviada',
  sended_quote: 'Cotización enviada',
  sendonly: 'Enviar',
  sequence: 'Secuencia | Secuencias',
  serial: 'Serial',
  service: 'Servicio',
  services: 'Servicios',
  settingImage: 'Configuración de imagen',
  settings_for_image_upload: 'Configuración para subida de imagen',
  settings: 'Configuraciones',
  settingTemplate: {
    dark_icons: 'Enlaces modo oscuro',
    setting: 'Configuración',
    settings_template: 'Configuraciones de plantilla de correo electrónico',
    image: 'Imagen | Imágenes',
    icons: 'Enlaces de redes sociales',
    text: 'Texto',
    test_text: 'Texto de prueba',
    align: {
      align: 'Alinear',
      center: 'Centrar',
      left: 'Izquierda',
      right: 'Derecha',
      justify: 'Justificar'
    },
    size: {
      size: 'Tamaño',
      small: 'Pequeño',
      medium: 'Medio',
      large: 'Grande'
    },
    text_color: 'Color del texto',
    font_size: 'Tamaño del texto',
    font_style: {
      both: 'Ambas',
      font_style: 'Estilo de fuente',
      italic: 'Cursiva',
      bold: 'Negrita',
      normal: 'Normal'
    },
    header: 'Encabezado',
    background_color: 'Color de fondo',
    body: 'Cuerpo',
    footer: 'Pie de página'
  },
  shipping_address: 'Dirección de Envío',
  shippingAddress: 'Dirección de envío',
  shop_list: 'Lista de Compra',
  show: 'Mostrar',
  side: 'Lado',
  sku_code: 'Código de Barras',
  sms: 'Sms',
  sunday: 'Domingo',
  thursday: 'Jueves',
  timezone: 'Zona horaria',
  token_expires_soon:
    'La conexión con WhatsApp vence el {date}. Volvé a conectar antes de esa fecha o la imprenta va a dejar de poder enviar mensajes.',
  total_conversations: 'Total de conversaciones',
  tuesday: 'Martes',
  unassigned: 'Sin asignar',
  unregistered_contact: 'Contacto no registrado',
  usage: 'Consumo',
  usage_hint: 'WhatsApp cobra por mensaje entregado, segun categoria y pais.',
  // Pantalla que ofrece el complemento de WhatsApp a quien no lo contrató
  whatsapp_addon_title: 'WhatsApp para tu imprenta',
  whatsapp_addon_subtitle:
    'Atiende a tus clientes por WhatsApp sin salir de iprintPOS.',
  whatsapp_addon_cta: 'Quiero activarlo',
  whatsapp_addon_contact_title: 'Activar el complemento',
  whatsapp_addon_contact_hint:
    'Escríbenos y lo activamos para tu empresa. Esta pantalla no envía ningún aviso.',
  whatsapp_addon_mock_1: 'Hola, necesito 500 tarjetas',
  whatsapp_addon_mock_2: '¿Me pasas la cotización?',
  whatsapp_addon_mock_3: 'Perfecto, lo apruebo',
  whatsapp_addon_mock_in: 'Hola, necesito 500 tarjetas para el lunes',
  whatsapp_addon_mock_out: 'Te paso la cotización ahora mismo',
  whatsapp_addon_mock_in_2: 'Gracias, la apruebo',
  whatsapp_addon_inbox_title: 'Una bandeja para todo el equipo',
  whatsapp_addon_inbox_text:
    'Las conversaciones se reparten en colas y se asignan a quien corresponde, con el historial a la vista.',
  whatsapp_addon_crm_title: 'El cliente, identificado',
  whatsapp_addon_crm_text:
    'Quien escribe queda vinculado a su ficha del CRM, o se da de alta desde la misma conversación.',
  whatsapp_addon_quote_title: 'Cotizar sin cambiar de pantalla',
  whatsapp_addon_quote_text:
    'Se arma la cotización y se manda el PDF desde la conversación, sin copiar datos a mano.',
  whatsapp_addon_approval_title: 'De la conversación a la orden',
  whatsapp_addon_approval_text:
    'El cliente responde en el chat y desde ahí se abre su cotización para aprobarla y convertirla, sin salir a buscarla.',
  whatsapp_addon_status_title: 'Avisos de producción',
  whatsapp_addon_status_text:
    'Cada cambio de estado de la suborden le llega al cliente por el canal que eligió.',
  whatsapp_addon_hours_title: 'Horarios y plantillas',
  whatsapp_addon_hours_text:
    'Horario de atención propio y plantillas aprobadas para responder fuera de hora.',
  walks_in: 'Venta directa',
  facebook: 'Facebook',
  instagram: 'Instagram',
  tik_tok: 'Tik Tok',
  soldby: 'Fórmula de venta',
  special_customer: 'Precios especiales para clientes',
  specific: 'Información específica',
  sporadic: 'Esporádico',
  start_date: 'Fecha de inicio | Fecha inicial',
  start_user_chat: 'Comenzar chat con el usuario',
  start_whatsapp_chat: 'Escribirle por WhatsApp',
  start_whatsapp_hint:
    'Este cliente todavía no escribió, así que WhatsApp sólo admite abrir la conversación con una plantilla aprobada.',
  state: 'Estado',
  status: 'Estado',
  stock: 'Inventario disponible',
  subcategory: 'Sub-Categoría',
  subdomain: 'Subdominio | Subdominios',
  subitem: 'Subdetalle | Subdetalles',
  subitems_not: 'Crear sin sub-detalles',
  subitems: 'Subdetalles {value}',
  subject: 'Sujeto',
  subname: 'Nombre del subproyecto',
  suborder_action: {
    created: 'creada',
    updated: 'actualizada',
    deleted: 'eliminada',
    access: 'accedida'
  },
  suborder_code: 'Código de la suborden',
  suborder_description: 'Descripción de la suborden',
  suborder_name: 'Nombre de la suborden',
  suborder: 'Suborden | Subórdenes',
  suborderstatus: 'Estado de la Suborden',
  subordersubstatus: 'Subestado de la Suborden',
  subtotal: 'Subtotal',
  success: '{model} {action} correctamente',
  suffix: 'Sufijo',
  summary: 'Sumario',
  supplier_manager: 'Administrador de proveedores',
  supplier_personal_info: 'Información Personal del Proveedor',
  supplier_type: 'Tipo de proveedor',
  supplier_type: 'Tipo de proveedor',
  supplier: 'Proveedor|Proveedores',
  supplierAddress: 'Dirección proveedor',
  supplierCompany: 'Nombre del proveedor o empresa',
  supplierlevel: 'Tipo de proveedor | Tipo de proveedores',
  suppliersReport: 'Reporte de proveedores',
  sustrate: 'Sustratos',
  tab_name: 'Nombre de las pestañas',
  tab: 'Pestaña',
  tabs: 'Pestañas',
  tabs_must_be_unique: 'El título de las pestañas debe ser único',
  tax_id: 'Número de Pago de Impuesto|Número de Pago de Impuesto (Opcional)',
  tax: 'Impuesto',
  taxes_info: 'Información sobre impuestos',
  telegram: 'Telegram',
  production_details_template: 'Plantilla de detalles de producción',
  template: 'Plantilla',
  templates_email: 'Plantilla de correo | Plantillas de correo',
  terms: 'Término de pago | Términos de pago',
  test_formula: 'Probar esta fórmula',
  text: 'Texto',
  textile_colors: 'Colores Textiles',
  there_are_no_images_yet: 'No existen imágenes aún',
  time: 'Tiempo',
  tip: 'Consejo|Consejos',
  title_color: 'Color del título',
  title_discount: 'Descuento',
  title_extra: 'Extra',
  title: 'Título',
  to: 'Hasta',
  total: 'Total',
  turnaround: 'Días de entrega',
  type_acquisition: 'Tipo de adquisición del equipo',
  type_recurrent: 'Tipo de recurrencia',
  type: 'Tipo',
  typecontact: 'Tipo de contacto|Tipos de contacto',
  typedate: 'Tipo de fecha',
  typedatealert:
    'Si no selecciona una plantilla, este tipo de fecha será general',
  unavailable: 'No disponible',
  unitprice: 'Precio unitario',
  unknown: 'Desconocido',
  update: 'Actualizar | Actualizado | actualizada | Actualizadas',
  updated_date: 'Fecha de carga',
  updated_user: 'Usuario que lo cargó',
  updated: 'Actualizado',
  upload_image: 'Subir imagen',
  upload_logo: 'Subir logotipo',
  user_panel: 'Panel de Usuarios',
  user: 'Usuario | Usuarios | usuario | usuarios',
  username: 'Nombre de usuario | Nombre de usuario / Correo',
  users_select: 'Seleccione los usuarios',
  users_set_groups: 'Usuarios asignados a grupos',
  users_set_permissions: 'Se asignaron permisos a los Usuarios',
  value_must_be_greater: '{value} debe ser mayor',
  value: 'Valor | Valores',
  voided: 'Anulado',
  wantToAssignDesigner: '¿Desea asignar Diseñador?',
  web_url: 'Dirección Web',
  wednesday: 'Miércoles',
  week: 'Semana',
  weekly: 'Semanal',
  weight_limit_exceeded:
    'El archivo que suministró excede el peso límite, por favor ingrese uno \
    más liviano.',
  welcome_company: 'Bienvenido a {value}',
  welcome: 'Bienvenido',
  what_groups: '¿Cuáles son los grupos para agregar?',
  what_permissions: '¿Cuáles son los permisos para agregar?',
  what_users: '¿Cuáles son los usuarios para agregar?',
  whatsapp: 'Whatsapp',
  no_orders_yet: 'Este cliente todavía no tiene órdenes',
  no_results_for: 'No hay resultados para «{search}»',
  whatsapp_active_for_company: 'WhatsApp activo para esta empresa',
  whatsapp_chat_started: 'Mensaje enviado',
  whatsapp_connected: 'Conectado con el número {phone}',
  whatsapp_connected_ok: 'WhatsApp conectado',
  whatsapp_error_131026:
    'El número no tiene WhatsApp o no puede recibir mensajes.',
  whatsapp_error_131030:
    'El número del cliente no está en la lista de prueba autorizada.',
  whatsapp_error_131047:
    'Pasaron más de 24 horas: hay que responder con una plantilla aprobada.',
  whatsapp_error_133010:
    'El número de la imprenta no está registrado en WhatsApp.',
  whatsapp_error_auth:
    'Las credenciales del canal vencieron. Hay que volver a conectar WhatsApp.',
  whatsapp_field_code: 'Código de la orden',
  whatsapp_field_name: 'Nombre del trabajo',
  whatsapp_field_status: 'Estado',
  whatsapp_not_configured: 'Esta empresa todavía no tiene WhatsApp configurado',
  whatsapp_state_attending: 'En atención',
  whatsapp_state_closed: 'Cerrada',
  whatsapp_state_follow_up: 'Seguimiento',
  whatsapp_state_new: 'Nueva',
  whatsapp_state_quote_sent: 'Cotización enviada',
  whatsapp_state_waiting_customer: 'Esperando cliente',
  whatsapp_status_active: 'Activa',
  whatsapp_status_failed: 'Con error',
  whatsapp_status_pending: 'Pendiente',
  whatsapp_status_provisioning: 'En alta',
  whatsapp_status_suspended: 'Suspendida',
  whatsapp_template_delivery: 'Pedido en camino',
  whatsapp_template_in_process: 'Pedido en producción',
  whatsapp_template_quote_sent: 'Cotización enviada',
  whatsapp_template_ready_to_deliver: 'Pedido listo',
  width: 'Ancho',
  window_authentication: 'Autenticación',
  window_closed:
    'Pasaron 24 horas desde el último mensaje del cliente. Sólo se puede responder con una plantilla aprobada.',
  window_marketing: 'Marketing',
  window_service: 'Servicio',
  window_utility: 'Utilidad',
  with_autoprice:
    'Los precios por porcentaje al guardar serán ajustados los montos \
    correspondientes acordes al costo',
  with_subitems: 'Con subdetalles',
  without: 'sin',
  without_price: 'Sin precio',
  without_subitems: 'Sin subdetalles',
  write_a_message: 'Escribe un mensaje',
  write_message: 'Escriba un mensaje',
  wrong_file_type: 'Tipo de archivo incorrecto',
  yearly: 'Anual',
  yes: 'Si',
  zip_code: 'Código Postal',
  zoom_in: 'Acercar',
  read: 'Leído',
  unread: 'No leído',
  apparel_colors: 'Colores textiles',
  hex_code: 'Código Hex',
  clone_colors: 'Clonar colores',
  select_at_least_one_color: 'Debe seleccionar al menos un color',
  no_colors_provided: 'No se proporcionaron colores',
  company_not_found: 'Empresa no encontrada',
  cannot_delete_color_associated:
    'No se puede eliminar el color porque está asociado a uno o más productos.',
  saved: 'Guardado correctamente',
  color_name_already_exists:
    'El color "{name}" ya existe por nombre en su listado.',
  color_name_exists: 'Ya existe un color con este nombre.',
  black: 'Negro',
  white: 'Blanco',
  navy_blue: 'Azul marino',
  red: 'Rojo',
  orange: 'Naranja',
  gray: 'Gris',
  apparel_readonly_message:
    'La configuración de textiles solo puede definirse al crear el producto.',
  cannot_delete_apparel_in_use:
    'No se puede eliminar la prenda porque está en uso.',
  apparel_name_already_exists: 'Ya existe una prenda con este nombre.',
  error_saving_apparel: 'Error al guardar la prenda.',
  cannot_delete_style_in_use:
    'No se puede eliminar el estilo porque está en uso.',
  style_name_already_exists:
    'Ya existe un estilo con este nombre para esta prenda.',
  error_saving_style: 'Error al guardar el estilo.',
  cannot_delete_fabric_in_use:
    'No se puede eliminar el tipo de tela porque está en uso.',
  fabric_name_already_exists: 'Ya existe un tipo de tela con este nombre.',
  error_saving_fabric: 'Error al guardar el tipo de tela.',
  cannot_delete_brand_in_use:
    'No se puede eliminar la marca porque está en uso.',
  brand_name_already_exists: 'Ya existe una marca con este nombre.',
  error_saving_brand: 'Error al guardar la marca.',
  cannot_delete_gender_in_use:
    'No se puede eliminar el género porque está en uso.',
  gender_name_already_exists: 'Ya existe un género con este nombre.',
  error_saving_gender: 'Error al guardar el género.'
}
